import DataTable, { type DataTableColumn } from '../components/DataTable';
import MetricCard from '../components/MetricCard';
import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import { StatusBadgeFor } from '../components/StatusBadge';
import { approvalsByStatus } from '../data/mockHelpers';
import type { Approval } from '../data/mock';
import DashboardLayout from '../components/DashboardLayout';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

function detailFor(a: Approval): string {
  switch (a.type) {
    case '报销':
      return `¥ ${a.amount?.toLocaleString('zh-CN') ?? '—'}`;
    case '请假':
    case '加班':
    case '出差':
      return `${a.days ?? '—'} 天`;
    default:
      return '—';
  }
}

const approvalColumns: DataTableColumn<Approval>[] = [
  { key: 'id', header: '编号', cell: (a) => a.id },
  { key: 'type', header: '类型', cell: (a) => a.type },
  { key: 'applicantName', header: '申请人', cell: (a) => a.applicantName },
  {
    key: 'detail',
    header: '金额 / 天数',
    cell: (a) => detailFor(a),
    align: 'right',
    numeric: true
  },
  {
    key: 'submittedAt',
    header: '提交时间',
    cell: (a) => a.submittedAt
  },
  {
    key: 'status',
    header: '状态',
    cell: (a) => StatusBadgeFor({ status: a.status })
  }
];

function ApprovalPage(props: BusinessPageProps) {
  const buckets = approvalsByStatus();
  const all = [...buckets.pending, ...buckets.approved, ...buckets.rejected];

  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{ heading: '审批管理', sub: '' }}
      metrics={[]}
      chart={{ title: '', data: [], xLabels: [] }}
      quickAccess={[]}
      activeSidebarId="approval"
      omitPageTitle
      settingsPanel={props.settingsPanel}
      mobileMenu={props.mobileMenu}
      sidebarOpen={props.sidebarOpen}
    >
      <PageHeader
        heading="审批管理"
        sub={`${buckets.pending.length} 条待办`}
        actions={<button type="button" className="is-primary">批量审批</button>}
      />
      <div className="axi-section">
        <div className="axi-metric-grid">
          <MetricCard label="待审批" value={String(buckets.pending.length)} unit="条" icon="document" />
          <MetricCard label="已通过" value={String(buckets.approved.length)} unit="条" icon="check" neutral />
          <MetricCard label="已驳回" value={String(buckets.rejected.length)} unit="条" icon="shield" neutral />
          <MetricCard label="总申请" value={String(all.length)} unit="条" icon="bar" neutral />
        </div>
      </div>
      <SectionCard title="审批记录" description="按 待审批 → 已通过 → 已驳回 顺序排序">
        <DataTable<Approval>
          columns={approvalColumns}
          rows={all}
          rowKey={(a) => a.id}
        />
      </SectionCard>
    </DashboardLayout>
  );
}

export default ApprovalPage;